import React from "react";
import { IoCloseSharp } from "react-icons/io5";
import LearnMore from "../ui/cards/buttons/LearnMore";

function DialogBox({ visible, close }) {
  return (
    <>
      {visible && (
        <>
          <div className='fixed inset-0 bg-black bg-opacity-60 flex justify-center items-center z-30'>
            <div className='bg-white rounded-md w-fit md:w-1/3 lg:w-1/4 p-5'>
              <div className='flex justify-between items-center mb-2.5'>
                <div>
                  <h1 className='text-gray-500 text-xl'>Appointment</h1>
                </div>
                <div>
                  <button
                    onClick={() => {
                      close();
                    }}
                  >
                    <IoCloseSharp
                      className='fill-gray-500 hover:fill-black'
                      size={25}
                    />
                  </button>
                </div>
              </div>
              <div>
                <form action=''>
                  <div className='mb-4'>
                    <input
                      className='outline-none border w-full focus:border-black rounded-sm p-3.5'
                      placeholder='Your Name'
                      type='text'
                      name=''
                      id=''
                    />
                  </div>
                  <div className='mb-4'>
                    <input
                      className='outline-none border w-full focus:border-black rounded-sm p-3.5'
                      placeholder='Your Email'
                      type='email'
                      name=''
                      id=''
                    />
                  </div>
                  <div className='flex justify-between items-center gap-5 sm:gap-0 w-full mb-4'>
                    <div>
                      <input
                        placeholder='Enter Date'
                        type='date'
                        name=''
                        id=''
                        className='outline-none border w-full focus:border-black rounded-sm p-3.5'
                      />
                    </div>
                    <div>
                      <input
                        placeholder='Enter Time'
                        type='time'
                        name=''
                        id=''
                        className='outline-none border w-full focus:border-black rounded-sm p-3.5'
                      />
                    </div>
                  </div>
                  <div className='mb-4'>
                    <textarea
                      className='outline-none border w-full focus:border-black rounded-sm p-3.5'
                      name=''
                      id=''
                      cols='10'
                      rows='4'
                      placeholder='Message'
                    ></textarea>
                  </div>
                  <div
                    onClick={() => {
                      close();
                    }}
                    className='inline-block'
                  >
                    <LearnMore title='Send Massage' />
                  </div>
                </form>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
}

export default DialogBox;
